import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";

interface IAlertMessageProps {
  message: string;
  icon: ReactNode;
  backgroundColor: string;
}

const AlertMessage = ({ message, icon, backgroundColor }: IAlertMessageProps) => {
  return (
    <Box className="flex items-center gap-2 ml-2">
      <Box
        className="flex items-center justify-center rounded-full shrink-0"
        sx={{
          width: 20,
          height: 20,
          backgroundColor,
        }}
      >
        {icon}
      </Box>
      <Typography fontSize={14}>{message}</Typography>
    </Box>
  );
};

export default AlertMessage;
